<template>
  <div class="card-pdf-nota-fiscal">
    <div class="content-grupo">
      <div class="template-pagina">
        <div class="imagem-template-cabecalho cabecalho-primeiraPag">
          <img src="@/assets/imgs/Cabecalho_Carta_Proposta.svg" class="img-rodape">

          <div class="info-nota-cabecalho espaco-data-rodape conteudo-cabecalho-primeiraPag">
            <div class="titulo-conteudo-detalhes titulo-cabecalho-nota-fiscal"><span class="numero-nota-fiscal"> Nota Fiscal - </span> {{infosNotaFiscal.SerieNotaFiscal}} / {{ infosNotaFiscal.CodigoExterno || infosNotaFiscal.CodigoFiscal }} </div>
            <div class="borda-grupo borda-nota-fiscal"></div>
            <div class="data-emissao titulo-conteudo-detalhes"><span class="numero-nota-fiscal"> Data de Emissão: </span> {{ DataEmissao }} </div>
          </div>
        </div>

        <div class="imagem-template-rodape">
          <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ DiaHoje }} </div>
          <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-cabecalho">
        </div> 
      </div>

      <div class="content-informacoes-nota-fiscal">
        <div class="detalhes-nota-fiscal">
          <div class="borda-titulo-grupo">
            <div class="titulo-grupo"> DETALHES </div>
            <div class="borda-grupo"></div>
          </div>

          <div class="conteudo-detalhes-nota-fiscal conteudo-grupo">
            <div class="representante">
              <div class="titulo-conteudo-detalhes"> Representante </div>
              <div class="label-conteudo">{{ infosNotaFiscal.NomeRepresentante }}</div>
            </div>
            
            <div class="cliente">
              <div class="titulo-conteudo-detalhes"> Cliente </div>
              <div class="label-conteudo">{{ infosNotaFiscal.RazaoSocial }}</div>
            </div>

            <div class="codigo-nota-fiscal">
              <div class="titulo-conteudo-detalhes"> Nota / Série </div>
              <div class="label-conteudo"> {{ infosNotaFiscal.CodigoExterno }}</div>
            </div>

            <div class="transportadora">
              <div class="titulo-conteudo-detalhes"> Transportadora </div>
              <div class="label-conteudo">{{ 'Sem dados' }}</div>
            </div>

            <div class="tipo-frete">
              <div class="titulo-conteudo-detalhes"> Tipo de Frete </div>
              <div class="label-conteudo">{{ infosNotaFiscal.IndicadorDeTipoFreteTexto }}</div>
            </div>

            <div class="porcentagem-frete">
              <div class="titulo-conteudo-detalhes"> % Frete </div>
              <div class="label-conteudo">{{ infosNotaFiscal.PercentualFrete }}%</div>
            </div>

            <div class="consignatario">
              <div class="titulo-conteudo-detalhes"> Consignatário </div>
              <div class="label-conteudo">{{ infosNotaFiscal.CodigoConsignatorio || 'Sem dados' }}</div>
            </div>

            <div class="zona-franca">
              <div class="titulo-conteudo-detalhes"> Zona Franca </div>
              <div class="label-conteudo">{{ infosNotaFiscal.ZonaFranca || 'Não' }}</div>
            </div>

            <div class="codigo-fiscal">
              <div class="titulo-conteudo-detalhes"> Código Fiscal </div>
              <div class="label-conteudo">{{ infosNotaFiscal.CodigoFiscal }}</div>
            </div>

            <div class="origem">
              <div class="titulo-conteudo-detalhes"> Origem </div>
              <div class="label-conteudo">{{ infosNotaFiscal.Origem }}</div>
            </div>

            <div class="situacao">
              <div class="titulo-conteudo-detalhes"> Situação </div>
              <div class="label-conteudo">{{ infosNotaFiscal.SituacaoTexto }}</div>
            </div>

            <div class="finalidade">
              <div class="titulo-conteudo-detalhes"> Finalidade </div>
              <div class="label-conteudo">{{ infosNotaFiscal.IndicadorFinalidadeTexto }}</div>
            </div>

            <div class="natureza-operacao">
              <div class="titulo-conteudo-detalhes"> Nat. Operação </div>
              <div class="label-conteudo">{{ infosNotaFiscal.DescricaoDaNaturezaDaOperacap }}</div>
            </div>

            <div class="peso-bruto-total">
              <div class="titulo-conteudo-detalhes"> Peso Bruto Total </div>
              <div class="label-conteudo">{{ infosNotaFiscal.PesoTotalBrutoFormatado }}</div>
            </div>

            <div class="peso-liquido-total">
              <div class="titulo-conteudo-detalhes"> Peso Líquido Total </div>
              <div class="label-conteudo">{{ infosNotaFiscal.PesoTotalLiquidoFormatado }}</div>
            </div>

            <div class="condicao-pagamento">
              <div class="titulo-conteudo-detalhes"> Cond.Pagto </div>
              <div class="label-conteudo">{{ infosNotaFiscal.FormaDePagamento }}</div>
            </div>

            <div class="porcentagem-desconto-ipi">
              <div class="titulo-conteudo-detalhes"> % Desconto IPI </div>
              <div class="label-conteudo">{{ infosNotaFiscal.PercentualDescontoIPI }}%</div>
            </div>

            <div class="ipi">
              <div class="titulo-conteudo-detalhes"> IPI </div>
              <div class="label-conteudo">{{ infosNotaFiscal.ValorTotalIPIFormatado }}</div>
            </div>

            <div class="porcentagem-icm">
              <div class="titulo-conteudo-detalhes"> % ICM </div>
              <div class="label-conteudo">{{ infosNotaFiscal.PercentualICMS }}%</div>
            </div>

            <div class="icm">
              <div class="titulo-conteudo-detalhes"> ICM </div>
              <div class="label-conteudo">{{ infosNotaFiscal.ValorTotalICMFormatado }}</div>
            </div>

            <div class="porcentagem-desconto">
              <div class="titulo-conteudo-detalhes"> % Desconto </div>
              <div class="label-conteudo">{{ infosNotaFiscal.ValorDescontoMercadoria }}%</div>
            </div>

            <div class="bonificacao">
              <div class="titulo-conteudo-detalhes"> Bonificação </div>
              <div class="label-conteudo">{{ infosNotaFiscal.ValorTotalBonificacao }}</div>
            </div>

            <div class="total-bruto">
              <div class="titulo-conteudo-detalhes"> Total Bruto </div>
              <div class="label-conteudo">{{ infosNotaFiscal.ValorTotalMercadoriaFormatado }}</div>
            </div>

            <div class="valor-total-nota">
              <div class="titulo-conteudo-detalhes"> Valor Total Nota </div>
              <div class="label-conteudo">{{ infosNotaFiscal.ValorTotalNotaFiscalFaturaFormatado }}</div>
            </div>
          </div>
        </div>

        <div class="nota-fiscal-outros">
          <div class="borda-titulo-grupo">
            <div class="titulo-grupo"> OUTROS </div>
            <div class="borda-grupo"></div>
          </div>

          <div class="conteudo-nota-fiscal-outros conteudo-grupo">
            <div class="representante-adicional">
              <div class="titulo-conteudo-detalhes"> Representante Adicional </div>
              <div class="label-conteudo">{{ infosNotaFiscal.RazaoSocial || 'Não possui' }}</div>
            </div>

            <div class="dados-adicionais-fiscal">
              <div class="titulo-conteudo-detalhes"> Dados Adicionais (fiscal) </div>
              <div class="label-conteudo">{{ infosNotaFiscal.DadosAdicionalFiscal || 'Não possui' }}</div>
            </div>

            <div class="dados-adicionais-livre">
              <div class="titulo-conteudo-detalhes"> Dados Adicionais (livre) </div>
              <div class="label-conteudo">{{ infosNotaFiscal.DadosAdicionalLivre || 'Não possui' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PDFNotaFiscal from './PDFNotaFiscal.js';
  export default PDFNotaFiscal;
</script>

<style scoped>
.content-grupo {
  position: relative;
  height: 70.125rem;
  width: 100%;
}
.template-pagina {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 2;
}
.imagem-template-cabecalho {
  display: flex;
  align-items: flex-start;
}
.imagem-template-rodape {
  position: relative;
  display: flex;
  align-items: flex-end;
}

.img-cabecalho, .img-rodape {
  width: 99.25%;
}

.info-nota-cabecalho {
  position: absolute;
  width: 99.25%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  row-gap: 0.8rem;
  padding: 1rem 1.2rem 0 0;
  top: 0;
  left: 0;
  z-index: 1000;
}

.info-nota-cabecalho .titulo-conteudo-detalhes {
  font-size: 0.85rem;
}

.titulo-cabecalho-nota-fiscal {
  padding-bottom: 0.2rem;
  margin-top: 10px !important;
}

.numero-nota-fiscal {
  font-weight: 500;
}

.titulo-grupo {
  width: 100%;
  color: #4f2c19;
  text-align: left;
  font-size: 1.1rem;
  font-family: "MontSerrat";
  font-weight: 700;
  padding-bottom: 0.3rem;
  letter-spacing: 1px;
}

.titulo-grupo-espacamento {
  margin-top: 5rem;
  row-gap: 3.5rem;
}

.borda-titulo-grupo {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8rem;
}

.borda-grupo {
  width: 5rem;
  height: 3px;
  background-color: #FCB315;
}

.borda-nota-fiscal {
  background-color: #4f2c19 !important;
  border-radius: 0.5rem;
  background-color: #4f2c19;
}

.data-emissao {
  margin-top: 0 !important;
}

.data-rodape {
  color: #fff !important;
  font-size: 0.75rem !important;
  font-weight: 500;
  position: absolute;
  height: 100%;
  width: 99.25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  left: 0;
  padding: 0.35rem 1.5rem 0.3rem 0;
  z-index: 2;
}

.conteudo-grupo {
  background-color: #F9F9F9;
  gap: 1rem 1.5rem;
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 0.5rem;
}

.content-informacoes-nota-fiscal {
  height: 100%;
  width: 99.25%;
  padding: 8.5rem 2rem 3rem;
}

.conteudo-detalhes-nota-fiscal {
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: repeat(4, 1fr);
}

.representante, .cliente {
  grid-column: span 4;
}

.nota-fiscal-outros {
  margin-top: 3rem;
}

.conteudo-nota-fiscal-outros {
  display: flex;
  flex-direction: column;
}

.conteudo-grupo .titulo-conteudo-detalhes {
  color: #3f3f3f;
  font-size: 0.8rem;
  margin-top: 0.1rem;
}

.conteudo-grupo .label-conteudo {
  color: #8a8a8a !important;
  font-size: 0.9rem;
  font-family: 'MontSerrat';
  margin-top: 0.2rem;
  margin-bottom: 0;
}
</style>
